import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors';
import * as background from '../../config/backgroundColor';
import * as legend from '../../config/legend';
import * as series from '../../config/series';
import * as tooltip from '../../config/tootip';
import * as xAxis from '../../config/xAxis';
import * as yAxis from '../../config/yAxis';
import * as brush from '../../config/brush';
import * as datazoom from '../../config/datazoom';
import * as grid from '../../config/grid';
import { CommonService } from '../../service/common.service';
import { EChartOption } from 'echarts';
import { ChartOptionService } from '../../service/chart-option.service';
import { ECharts } from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class BoxPlotLineService {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService
  ) { }

  // 获取X轴配置
  getChartxAxis(number) {
    let xAxisOption: EChartOption.XAxis[] = this.chartOptionService.getChartxAxis(number);
    xAxisOption.forEach(e => {
      e['boundaryGap'] = true;
    })
    return xAxisOption;
  }

  // 获取Y轴配置
  getChartyAxis(number) {
    let yAxisOption: EChartOption.YAxis[] = this.chartOptionService.getChartyAxis(number);
    yAxisOption[1].splitLine.show = false;
    return yAxisOption;
  }

  // 设置X轴刻度显示间隔
  setInterval(option: any, interval: Number) {
    option.xAxis[0].axisLabel.interval = interval;
  }

  // 顶部legend变化
  topLegendChange(legendData: any[], optionInit: ECharts) {
    legendData.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        })
      }
    })
  }

  // 获取盒须图系列
  getDefaultBoxPlotSeries() {
    let seriesOption: EChartOption.SeriesBoxplot = this.chartOptionService.getDefaultBoxPlotSeries();
    return seriesOption;
  }

  // 获取散点系列
  getDefaultScatterSeries() {
    let seriesOption: EChartOption.Series = this.chartOptionService.getDefaultScatterSeries();
    return seriesOption;
  }

  // 设置smallMode
  setSmallModeGrid(gridOption: EChartOption.Grid) {
    gridOption.top = grid.baseSmallPadding;
    gridOption.bottom = grid.baseSmallPadding;
    gridOption.left = grid.baseSmallPadding;
    gridOption.right = grid.baseSmallPadding;
  }

  // 获取盒须图tooltip
  getBoxPlotTooltip(unit: string = '') {
    let tooltipOption = this.chartOptionService.getBoxPlotTooltip(unit);
    return tooltipOption;
  }

  // 设置小边距模式padding
  setSmallModePadding(component) {
    component.cardPadding = "0rem";
  }

  // 设置tooltip单位
  setTooltipUnit(tooltipOption: EChartOption.Tooltip, unit: string | string[]) {
    tooltipOption.formatter = tooltip.getBoxPlotTooltipOfAxisChart(unit).formatter;
  }

  // 设置x轴名
  setXaxisName(xAxisOption: EChartOption.XAxis[], xAxisName: string) {
    xAxisOption.forEach(e => {
      e.name = xAxisName;
    })
  }
  // 设置y轴名
  setYaxisName(yAxisOption: EChartOption.YAxis[], yAxisName: string[]) {
    yAxisOption.forEach((e, i) => {
      e.name = yAxisName[i];
    })
  }
  // 设置y轴名距离
  setYNameGap(yAxisOption: EChartOption.YAxis[], yNameGap: number | number[]) {
    if (typeof (yNameGap) === 'number') {
      yAxisOption.forEach(e => {
        e.nameGap = yNameGap;
      })
    } else if (Array.isArray(yNameGap)) {
      for (let i = 0; i < yAxisOption.length; i++) {
        const element = yAxisOption[i];
        element.nameGap = yNameGap[i];
      }
    }
  }

  // 设置x轴label旋转
  setXAxisLabelRotate(xAxisOption: EChartOption.XAxis[], xAxisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    xAxisOption.forEach(element => {
      element.axisLabel.rotate = rotate;
      element.axisLabel.formatter = (value: string) => {
        let valueText = '';
        if (value.length > 5) {
          valueText = value.substring(0, 5) + '...'
        } else {
          valueText = value;
        }
        return valueText;
      }
    })
  }

  changeChartTitleDark(component, darkMode: boolean) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }

  setLegendPosition(gridOption: EChartOption.Grid, legendOption, legendPosition: string) {
    let style = this.commonService.changeFontSize()
    switch (legendPosition) {
      case "top":
        legendOption.show = false;
        gridOption.bottom = style.topLegendGrid.bottom;
        break;
      case "right":
        // gridOption.right = legend.rightLegendWidh;
        gridOption['top'] = style.rightLegendGrid.top;
        gridOption['right'] = style.rightLegendGrid.right;
        gridOption['left'] = style.rightLegendGrid.left;
        gridOption['bottom'] = style.rightLegendGrid.bottom;

        legendOption['top'] = '14%'
        legendOption['right'] = 0;
        legendOption['width'] = legend.rightLegendWidth;
        legendOption['bottom'] = gridOption.bottom;
        legendOption['orient'] = "vertical";
        legendOption['pageIcons'] = {
          vertival: [
            "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
            "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
          ],
        };
        legendOption['textStyle']['padding'] = [2, 0, 0, 0];
        break;
      case "none":
        legendOption.show = false;
        gridOption.bottom = style.smallNoLegendGrid.bottom;
        break;
      default:
        gridOption.bottom = legend.bottomLegendHeight;
        break;
    }
  }
  // 背景色的darkMode
  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;
  }
  // 设置x轴的darkMode
  xAxisDarkMode(xAxisOption: EChartOption.XAxis[]) {
    xAxisOption.forEach(e => {
      if (_.isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (_.isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
    });
  }
  // 设置y轴darkMode
  yAxisDarkMode(yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      if (_.isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (_.isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
      if (_.isNil(e['splitLine'])) {
        e['splitLine'] = {
          lineStyle: {
            color: color.darkModeTextColor
          }
        };
      } else {
        if (_.isNil(e['splitLine']['lineStyle'])) {
          e['splitLine']['lineStyle'] = {
            color: color.darkModeTextColor
          }
        } else {
          e['splitLine']['lineStyle']['color'] = color.darkModeTextColor;
        }
      }
    });
  }
  // 文字颜色DarkMode
  colorsDarkMode(chartColor: string[]) {
    chartColor.length = 0;
    color.darkModeColors.forEach(e => chartColor.push(e))
  }

  chartColorsChange(colors: string[], colorList: string[]) {
    colors.length = 0;
    colorList.forEach(e => {
      colors.push(e);
    })
  }

  // 图例的darkMode
  legendDarkMode(legendOption) {
    if (_.isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }
  // 系列的darkMode
  seriesDarkMode(seriesOption: EChartOption.Series) {
    if (_.isNil(seriesOption['label'])) {
      seriesOption['label'] = {};
    }
    seriesOption['label']['color'] = color.darkModeTextColor;
  }

  buildSeries(chartData, chartSeriesList: EChartOption.Series[], xAxisOption: EChartOption.XAxis[], boxPlotSeriesOption: EChartOption.Series, scatterSeriesOption: EChartOption.Series, lineSeriesOption: EChartOption.Series) {
    chartSeriesList.length = 0;
    if (chartData.hasOwnProperty('seriesName')) {
      for (let i = 0; i < chartData.seriesName.length; i++) {
        if (i === 0) {
          for (let j = 0; j < chartData.seriesName[i].length; j++) {
            let boxPlotSeries: EChartOption.Series = _.cloneDeep(boxPlotSeriesOption);
            let scatterSeries: EChartOption.Series = _.cloneDeep(scatterSeriesOption);

            if (chartData.hasOwnProperty('boxData') && !_.isNil(chartData.seriesName[i][j])) {
              boxPlotSeries['name'] = chartData.seriesName[i][j];
              boxPlotSeries['data'] = chartData.boxData[j]
            }
            if (!_.isNil(chartData.boxData[j]) && chartData.hasOwnProperty('scatterData')) {
              scatterSeries['name'] = chartData.seriesName[i][j];
              scatterSeries['data'] = chartData.scatterData[j];
            }
            chartSeriesList.push(boxPlotSeries);
            chartSeriesList.push(scatterSeries);
          }
        } else {
          for (let j = 0; j < chartData.seriesName[i].length; j++) {
            let lineSeries: EChartOption.Series = _.cloneDeep(lineSeriesOption);
            if (chartData.hasOwnProperty('lineData') && !_.isNil(chartData.lineData[j])) {
              lineSeries['name'] = chartData.seriesName[i][j];
              lineSeries['data'] = chartData.lineData[j];
              lineSeries['yAxisIndex'] = i;
            }
            if (chartData.hasOwnProperty('markArea') && !_.isNil(chartData.markArea[j])) {
              lineSeries['markArea']['data'] = chartData.markArea[j];
            }
            chartSeriesList.push(lineSeries);
          }
        }
      }
      if (!_.isNil(chartData.xData)) {
        xAxisOption.forEach(e => {
          e.data = chartData.xData;
        })
      }
    }
  }

  setSeriesDimensionNames(boxPlotSeriesOption: EChartOption.SeriesBoxplot, dimensionNames) {

    let names = ['x'].concat(dimensionNames);

    boxPlotSeriesOption.dimensions = names;
  }

  changeYAxisLabelSplit(yAxisOption: EChartOption.YAxis[], splitSwitch) {
    if (splitSwitch == false) {

      yAxisOption.forEach(element => {
        element['axisLabel'].formatter = (value): string => {
          return value.toFixed(0);
        }
      })

    }
  }

  setYAxisMin(yAxisOption: EChartOption.YAxis[], yAxisMin: number[]) {
    yAxisOption.forEach((e, i) => {
      e.min = yAxisMin[i];
    })
  }

  setYAxisMax(yAxisOption: EChartOption.YAxis[], yAxisMax: number[]) {
    yAxisOption.forEach((e, i) => {
      e.max = yAxisMax[i];
    })
  }

  setYAxisInterval(yAxisOption: EChartOption.YAxis[], yAxisInterval: number[]) {
    yAxisOption.forEach((e, i) => {
      e.interval = yAxisInterval[i]
    })
  }

}
